<div
  class="exchange-container"
  [class.expand]="exchangeCardOpened"
  (mousedown)="onCloseCryptoCard()"
>
  <app-crypto-search-bar
    [class.hide]="exchangeCardOpened"
    (searchChange)="cryptoSearch($event)"
  ></app-crypto-search-bar>

  <div *ngIf="!emptyCoins" class="selector" [class.hide]="exchangeCardOpened">
    <p class="selector-title">Comprar con</p>
    <div class="choice">
      <div class="circle" [class.isActive]="currency === CURRENCY_FILTER.ARS"></div>
      <div class="pill" (click)="changeCurrency(CURRENCY_FILTER.ARS)">
        <p [class.active]="currency === CURRENCY_FILTER.ARS">AR$</p>
      </div>
      <div class="pill" (click)="changeCurrency(CURRENCY_FILTER.USD)">
        <p class="option" [class.active]="currency === CURRENCY_FILTER.USD">U$D</p>
      </div>
    </div>
  </div>

  <p class="title" *ngIf="stableCryptos.length" [class.hide]="exchangeCardOpened">Estables</p>
  <div
    class="cards-section"
    *ngIf="stableCryptos.length"
    [ngClass]="exchangeCardOpened ? 'hide' : 'show scrollable'"
  >
    <app-basic-crypto-card
      *ngFor="let crypto of getCryptoListByCurrency(stableCryptos)"
      [crypto]="crypto"
      [prices]="getPrices(crypto)"
      [exchangeCardOpened]="exchangeCardOpened"
      [isArsCurrency]="currency === CURRENCY_FILTER.ARS"
      (click)="selectCoinCard(crypto)"
    ></app-basic-crypto-card>
  </div>
  <p
    class="title"
    *ngIf="getCryptoListByCurrency(volatilCryptos).length"
    [class.hide]="exchangeCardOpened"
  >
    No estables
  </p>
  <div
    class="cards-section"
    *ngIf="volatilCryptos.length"
    [ngClass]="exchangeCardOpened ? 'hide' : 'show scrollable'"
  >
    <app-basic-crypto-card
      *ngFor="let crypto of getCryptoListByCurrency(volatilCryptos)"
      [crypto]="crypto"
      [prices]="getPrices(crypto)"
      [exchangeCardOpened]="exchangeCardOpened"
      [isArsCurrency]="currency === CURRENCY_FILTER.ARS"
      (click)="selectCoinCard(crypto)"
    ></app-basic-crypto-card>
  </div>
  <h3 class="subtitle" [class.hide]="exchangeCardOpened">
    Las operaciones de activos digitales se realizan a través de Sixalime SAS - 30716788543.
  </h3>
  <div class="blur-background" [class.hide]="!exchangeCardOpened"></div>
</div>
<router-outlet></router-outlet>
